<template>
	<!-- 小店订单 -->
	<div class="myorder">
		<cube-page type="myorder-view" title="分销订单">
			<div slot="content">
				<van-tabs v-model="active" class="leoshop-content" @change="OnChange">
					<van-tab title="全部订单" name="0">
						<van-pull-refresh v-model="refreshing[0]" @refresh="onRefresh(0)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[0].loading" :finished="vantList[0].finished"
								finished-text="没有更多了" @load="onLoad(0)" :immediate-check="false">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span> {{item.order_status_text}}</span>
										</p>
									</div>
									<van-card :num="item.total_num" :title="item.goods_name"
										:thumb="item.goods_image"
										@click="goDetail($event,item.id,item.order_status_text)">
										<template #price-top>
											<div class="carflex">
												<div>
													<div class="carddesc">
														<span>使用时间：</span>
														<span>{{item.use_date}}</span>
													</div>
													<div class="carddesc">
														<span>下单时间：</span>
														<span>{{item.createtime}}</span>
													</div>
												</div>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">
												<span v-if="item.order_status_text !='待支付'">实付款</span>
												<span v-else>待付款</span>
												¥<span class="price" v-html="decimalPoint(item.pay_price)"></span>
											</div>
										</template>

									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="待确认" name="1">
						<van-pull-refresh v-model="refreshing[1]" @refresh="onRefresh(1)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[1].loading" :finished="vantList[1].finished"
								finished-text="没有更多了" @load="onLoad(1)" :immediate-check="false">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx"
									@click="goDetail($event,item.id)">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">{{item.order_status_text}}</p>
									</div>
									<van-card :num="item.total_num" :price="item.goods_price" :title="item.goods_name"
										:thumb="item.goods_image">
										<template #desc>
											<div class="ells2 carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>

					<van-tab title="待支付" name="2">
						<van-pull-refresh v-model="refreshing[2]" @refresh="onRefresh(2)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[2].loading" :finished="vantList[2].finished"
								finished-text="没有更多了" @load="onLoad(2)" :immediate-check="false">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span> {{item.order_status_text}}</span>
										</p>
									</div>
									<van-card :num="item.total_num" :price="item.goods_price" :title="item.goods_name"
										:thumb="item.goods_image"
										@click="goDetail($event,item.id,item.order_status_text)">
										<template #desc>
											<div class="ells2 carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carflex">
												<div>
													<div class="carddesc">
														<span>使用时间：</span>
														<span>{{item.use_date}}</span>
													</div>
													<div class="carddesc">
														<span>下单时间：</span>
														<span>{{item.createtime}}</span>
													</div>
												</div>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">待付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="待核销" name="3">
						<van-pull-refresh v-model="refreshing[3]" @refresh="onRefresh(3)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[3].loading" :finished="vantList[3].finished"
								finished-text="没有更多了" @load="onLoad(3)" :immediate-check="false">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span> 待核销</span>
										</p>
									</div>
									<van-card @click="goDetail($event,item.id)" :num="item.total_num"
										:price="item.goods_price" :title="item.goods_name" :thumb="item.goods_image">
										<template #desc>
											<div class="ells2 carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carflex">
												<div>
													<div class="carddesc">
														<span>使用时间：</span>
														<span>{{item.use_date}}</span>
													</div>
													<div class="carddesc">
														<span>下单时间：</span>
														<span>{{item.createtime}}</span>
													</div>
												</div>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="已完成" name="4">
						<van-pull-refresh v-model="refreshing[4]" @refresh="onRefresh(4)">
							<van-empty v-if="isNoData" class="custom-image"
								image="https://img01.yzcdn.cn/vant/custom-empty-image.png" description="您还没有相关的订单" />
							<van-list v-else v-model="vantList[4].loading" :finished="vantList[4].finished"
								finished-text="没有更多了" @load="onLoad(4)" :immediate-check="false">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx"
									@click="goDetail($event,item.id)">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">{{item.order_status_text}}</p>
									</div>
									<van-card :num="item.total_num" :price="item.goods_price" :title="item.goods_name"
										:thumb="item.goods_image">
										<template #desc>
											<div class="carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>

				</van-tabs>
			</div>
		</cube-page>
		<cube-view></cube-view>
		<SelectZf ref="selectZf" />
	</div>
</template>

<script>
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '../../TP/cube-page.vue'
	import SelectZf from '../../NewPages/selectzf.vue'
	import * as util from '@/utils/network'
	import {
		_debounce
	} from '@/utils/fd'
	import {
		Dialog,
		Toast
	} from 'vant';

	export default {
		components: {
			CubePage,
			CubeView,
			SelectZf
		},
		data() {
			return {
				vantList: [{
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}],
				refreshing: [false, false, false, false, false],
				OrderList: [],
				active: 0,
				isNoData: false,
				gcfg: [],
				pageIndex: 1,
				pageTotal: 0,
				title: this.$route.query.n,
			};
		},
		created() {
			this.get_my_order(this.active)
			this.gcfg = this.$store.getters.getGcfg
		},
		methods: {
			// 跳转详情页
			goDetail(event, id, status) {
				// 阻止a标签跳转
				event.preventDefault()
				if (event.target.outerText == '去支付' || event.target.outerText == '申请退款') {
					return;
				}
				this.$router.push({
					path: 'leoorder/detail',
					query: {
						id: id,
						update: false,
						noShow: true
					}
				})
			},
			//下拉刷新
			onRefresh(status) {
				// 清空列表数据
				this.vantList[status].finished = false;

				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态

				this.vantList[status].loading = true;
				this.get_my_order(status);
			},
			// 上滑加载更多
			onLoad(status) {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.get_my_order(status);
				}, 100)
			},
			// 获取数据
			get_my_order(status) {
				let that = this;

				let param = {
					status: status == 0 ? '' : status,
					page: that.pageIndex
				}
				var url = "/addons/litestore/api.distributor/getDownstreamOrder"
				if (that.title == 1) {
					param.store_id=that.$route.query.did
					url = "/addons/litestore/api.store/getDownstreamOrder"
				}else{
					param.did=that.$route.query.did
				}
				status = (status == '' || status == undefined || status == null) ? 0 : status;
				if (that.refreshing[status]) {
					that.clearContainer();
					that.refreshing[status] = false;
				}
				if (that.pageIndex > 1 && that.OrderList.length >= that.pageTotal) {
					that.vantList[status].finished = true;
					return;
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						that.vantList[status].loading = false;
						//这里对状态 进行分类
						that.pageTotal = result.data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (result.data.list == null || result.data.list.length === 0) {
							// 加载结束
							that.vantList[status].finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.OrderList = that.OrderList.concat(result.data.list);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.OrderList.length >= that.pageTotal) {
							that.vantList[status].finished = true;
							return;
						}
					},
				);
			},

			OnChange(name, title) {
				let that = this;
				that.clearContainer()
				that.get_my_order(name)
			},
			// 初始化数据
			clearContainer() {
				this.vantList = [{
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}],
					this.OrderList = [],
					this.isNoData = false,
					this.pageIndex = 1,
					this.pageTotal = 0
			},
			decimalPoint(val) {
				const splitPrice = (val || '0.00').split('.');
				const numb1 = splitPrice[0];
				var numb2 = '00';
				if (splitPrice.length > 1) {
					numb2 = splitPrice[1];
				}
				return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
			}
		}
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../../assets/css/order.css");
</style>
<style type="text/css">
	.van-card {
		background: transparent !important;
	}
</style>
